import { state } from "../state";

/* Variables */
const style = document.createElement('style');
const wallpaperVideoWebm = require("url:../assets/home.webm")
const wallpaperVideoMp4 = require("url:../assets/home.mp4")
const whatsappIMG = require("url:../assets/icon-whatsapp.png")

/* Class Welcome */
export class WelcomePage extends HTMLElement {

    connectedCallback() {
        this.render();
        state.dataWelcome();
    }

    render() {
        this.className = 'welcome-page';
        this.innerHTML =
        `
        <div class="page-container">
            <div class="page-body" style="flex-direction:column;">
                <!-- Hero -->
                <video class="wallpaper" autoplay loop muted playsinline>
                    <source src="${wallpaperVideoWebm}" type="video/webm">
                    <source src="${wallpaperVideoMp4}" type="video/mp4">
                </video>

                <div class="body-box">
                    <div class="body__break"></div>

                    <div class="body__wa">
                        <p>Agenda tu turno al </p>
                        <h3>+549 358 4675800</h3>
                        <p>ó</p>
                        <a href="https://wa.me/5493584675800" class="formulario" target="_blank">
                            <img src="${whatsappIMG}" alt="whatsapp" class="formulario__icon">
                            Escribinos
                        </a>
                    </div>

                    <div class="body__break"></div>

                    <div class="body__ubicacion">
                        <div class="body__cuerpo-text">
                            <h3 class="body__cuerpo-text-title">Sede Central</h3>
                            <h5 class="body__cuerpo-text-subtitle right">Dirección: Bv. Roca 949 - Rio Cuarto <br> Lineas Rotativas: +549 358 4675800 <br> Contacto: info@sanatorioprivado.com.ar</h5>
                        </div>
                        <div class="body__cuerpo-map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13364.847665217008!2d-64.3399908!3d-33.1297968!3m2!1i1024!2i768!4f3!3m3!1m2!1s0x95d20007b4855555%3A0x148336ad0c4d8c8b!2sPrestaciones%20Integrales%20Medicas%20Sa!5e0!3m2!1ses!2sar!4v1699966049624!5m2!1ses!2sar" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>

                    <div class="body__break"></div>
                </div>
            </div>
        </div>
        `
        style.innerHTML =
        `
        .wallpaper{
            height: 500px;
            width: 100%;
            object-fit: cover;
            background-color: #1E1E1E75;
        }
        .body__break{
            height: 35px;
        }
        .body__noticias{
            background-color: #1e1e1e10;
            min-height: 300px;
            width: 100%;
            display: grid;
            grid-template-columns: 33% 33% 33%;
            justify-content: center;
            padding: 25px;
            gap: 10px;
        }
        .body__wa{
            background-color: #1e1e1e10;
            min-height: 100px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 23px;
            gap: 20px;
        }
        .formulario{
            display: flex;
            align-items: center;
            gap: 10px;
            background-color: whitesmoke;
            color: #1e1e1e;
            border-radius: 50px;
            font-size: 20px;
            font-weight: 500;
            text-decoration: none;
            padding: 10px 22px;
            transition: background-color 0.3s, transform 0.2s;
        }
        .formulario:hover{
            background-color: #ffffff;
            transform: scale(1.05);
        }
        .formulario__icon{
            height: 28px;
            width: 28px;
        }
        .noticias{
            display: flex;
            flex-direction: column;
            min-height: 250px;
            align-items: center;
            gap: 20px;
        }
        .noticias__title{
            margin: 0 auto;
            font-size: 25px;
            text-align: center;
        }
        .noticias__subtitle{
            font-size: 15px;
        }
        .noticias__photo{
            height: 200px;
            width: 100%;
            background-color: #1E1E1E75;
        }
        .body__ubicacion{
            background-color: #1e1e1e10;
            height: 300px;
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
            gap: 20px;
        }
        .body__cuerpo-map{
            height: 300px;
            width: 60%;
        }
        `
        this.appendChild(style)
    }
}

/* Define */
customElements.define("welcome-page", WelcomePage)
